/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef ,useContext } from "react";
import {
	Grid,
	FormControl,
	Box,
	Typography,
	InputLabel,
	TextField,
	OutlinedInput,
	IconButton,
	InputAdornment,
	Autocomplete,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CardHeader } from "../../../components";
import "./style.scss";
import { configurationServices } from "../../../constants/configurationServices";
import { useDispatch, useSelector } from "react-redux";
import FXCMAutoComplete from "../../../components/common/FXCMAutoComplete";
import { authenticateUser } from "../../../services/auth.service";
import Header from "../../../components/layout/Header";
import { updateUserInfo } from "../../../reducers/userInfoSlice";
import { errorFlat, infoError } from "../../../constants/ImageConstants";
import {
	authenticationError,
	getUserCurrentLocation,
	languagequeryParam,
	setCountryListInState,
	setUserEntity,
	arabicLanguagequeryParam,
	coolingPeriodSlice
} from "../../../reducers/signUpSlice";
import FXCMErrorHandling from "../../../components/common/FXCMErrorHandling";
import { analytics } from "../../../utils/analytics/analytics";
import FXCMTrans from "../../../components/common/FXCMTrans";
import EsmaBanner from "../../../components/layout/EsmaBanner/EsmaBanner";
import CardSubHeader from "../../../components/CardSubHeader";
import useDirectionHook from "../../../hooks/useDirectionHook";
import { 
	HAVING_NUMERIC, HAVING_UPPERCASE_LETTERS, HAVING_LOWERCASE_LETTERS, CUSTOM_EMAIL,
	ONLY_ALPHA_NUMERIC, SPECIAL_REGEX_FOR_EMAIL, CONSECUTIVE_REGEX, CHECK_LENGTH_MIN_8_MAX_15,
	HAVING_SPACE, CERTAIN_SPECIAL_CHARECTORS, EMAIL_AUTO_SUGGESTION
} from "../../../utils/regex";
import Loader from "../../../components/Loader";
import LocaleContext from "../../../context/LocaleContext";
import DOMPurify from 'dompurify';
import { resolveCountryBlockedMessage, isCountryBlockedResponse } from "../../../utils/countryBlocked";
import { getEuOnlyCountryList } from "../../../utils/euOnlyCountryList";

const SignUpForm = () => {
	sessionStorage.removeItem("uPassToken");
	sessionStorage.removeItem("usermail");
	const [preSelectedLocation] = useState(() => DOMPurify.sanitize(sessionStorage.getItem("PRE_SELECTED_COUNTRY") || ""));
	
	const dispatch = useDispatch();
	const { t: getLabel } = useTranslation();
	const {
		getAllEnLabels,
		signUpRes,
		userEntity,
		authError,
		rbName,
		autoLoginResponse,
		loginRes,
		authRes, 
		authenticationResponse, 
		esmaText, 
		languageParam,
		coolingPeriod,
		langList
	} = useSelector((state) => state.signUp);
	const { entityLanguageList } = useSelector((state) => state.common)
	const { ip, currentCountry } = useSelector((state) => state.ipAddress);
	const user = useSelector((state) => state.user);
	const emailRef = React.useRef();
	const passwordRef = React.useRef(null);
	const emailExistOrAdditionalLabel = useRef("");
	const euGeoMountedRef = useRef(false);
	// Guards the pre-selected-country auto-select so it runs at most once.
	// Without this, a later config/countriesList refetch (e.g. after selecting a
	// country whose entity differs, or after the Arabic language remount) re-fires
	// the effect and clobbers the user's manual selection back to the stale
	// preSelectedLocation, silently un-blocking a restricted country. See CX-50769.
	const hasAutoSelectedPreselectedRef = useRef(false);
	const [direction] = useDirectionHook(languageParam);

	const userData = user?.user || false;
	const savedCurrencyValue = user?.user?.denomination || null;
	const platform = user?.user?.platform || null;

	const [config, setConfig] = useState();
	const [countriesList, setCountriesList] = useState();
	const [euNoPreSelect, setEuNoPreSelect] = useState(false);
	const [entity, setEntity] = useState("");
	const [restrictedCountriesList, setRestrictedCountriesList] = useState();
	// CX-51004/CX-51021: resolved async (cross-entity aware — see countryBlocked.js),
	// not at render, since the correct entity's bundle now has to be fetched
	// directly rather than read off the currently loaded i18next instance.
	const [countryBlockedMessage, setCountryBlockedMessage] = useState(null);
	const [countryType, setCountryType] = useState("");
	const [fxcmError, setFxcmError] = useState(false);
	const [emailLengthError, setEmailLengthError] = useState(false);
	const [plateformData, setPlateformData] = useState([]);
	const [link, setLink] = useState();
	const [productDisclosureLink, setProductDisclosureLink] = useState("");
	const [financialGuideLink, setFinancialGuideLink] = useState("");
	const [termsOfBusinessLink, setTermsOfBusinessLink] = useState("");
	const [targetMarketLink, setTargetMarketLink] = useState("");
	const [currencyList, setCurrencyList] = useState();
	const [alreadyExistError, setAlreadyExistError] = useState(false);
	const [isFindLanguage, setIsFindLanguage] = useState(false);
	const [focus, setFocus] = useState(false);
	const [signupLoader, setSignupLoader] = useState(false);
	const [ onboardingInComplete, setOnboardingInComplete ] = useState( false );
    const [emailConset, setEmailConset] = useState(true);
	const [smsConsent, setSmsConset] = useState(true);
	const [marketingConsent, setMarketingConsent] = useState(true);
	const [invalidPass, setInvalidPass] = useState(false); 
	const [skipEmailField, setSkipEmailField] = useState(false)
	const [accountLock, setAccountLock] = useState(false)
	
	const { setLocale } = useContext(LocaleContext);

	const { contactLink } = useSelector((state) => state.common);

	const [error, setError] = useState({
		email: false,
		password: false,
		country: false,
	} );
	const [touched, setTouched] = useState({
		email: false,
		password: false,
		country: false,
	});

	const [values, setValues] = React.useState({
		country: "",
		password: "",
		showPassword: false,
		email: "",
	});
	const [mandatoryError, setMandatoryError] = useState({
		email: false,
		password: false,
		country: false,
	});
	
	const queryParameters = new URLSearchParams(window.location.search);
	const campaignId = queryParameters.get("cmp");
	const irpid = queryParameters.get("irpid");
	const product = queryParameters.get("product");
	const coreg = queryParameters.get("coreg");
	const urlLang = queryParameters.get("lang");
	const isEuOnly = queryParameters.get("eid") === "1";
	const [filteredDomains, setFilteredDomains] = useState([]);
  	const [domains, setDomains] = useState();
  	const [suggestion, setSuggestion] = useState();
	const [highlightedOption, setHighlightedOption] = useState(null);

	const fetchDomainJson = () => {
		fetch(configurationServices(userEntity).domains)
		  .then((response) => {
			return response.json();
		  })
		  .then((data) => {
			setDomains(data);
		  })
		  .catch((e) => {
			
			console.log(e.message);
		  });
	  };

	useEffect(() => {
		fetchCountryJson();
		fetchFxcmRestrictedCountriesJson();
		fetchDomainJson();
	}, [] );

	useEffect(() => {
		if (!isEuOnly) return;
		if (!euGeoMountedRef.current) {
			euGeoMountedRef.current = true;
			return;
		}
		fetchCountryJson();
	}, [currentCountry]);

	useEffect( () =>
	{
	}, [ fxcmError ] )

	useEffect(() => {
		if (!domains || !values?.country) {
		  return; // Exit early if domains or values.country is falsy
		}
		const filteredCountryDomains = domains.find((domain) => Object.keys(domain)[0] === values.country) || [];
		let filteredArray = filteredCountryDomains[values?.country];
		if (filteredArray?.length > 0) {
		  const options = filteredArray.map((domain, index) => ({
			id: String(index + 1),
			label: domain,
		  }));
		  setSuggestion(options);
		} else {
		  const optionDefault = domains[0].default.map((domain, index) => ({
			id: String(index + 1),
			label: domain,
		  }));
		  setSuggestion(optionDefault);
		}
	  }, [domains, values.country]);

	useEffect( () =>{
		handleSuggessionOnCountryChange();
	}, [suggestion] )

	useEffect(() => {
		fetchJson();
		if (userEntity && userEntity !== "FXCMNO") {
			fetchJsonCurrency();
			fetchJsonPlatForm();
		}
	}, [userEntity]);
 
	const fetchJson = () => {
		fetch(configurationServices(userEntity).signUpURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setConfig(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};

	useEffect(() => {
		if (config && userEntity && userEntity !== "FXCMNO") {
			let data = config;
			const filteredproduct_Link = data?.PRODUCT_DISCLOSURE_URL?.filter(
				(value) => value.locale === languageParam)?.[0]?.link;

			const filteredFinancial_Link = data?.FINANCIAL_SERVICE_URL?.filter(
				(value) => value.locale === languageParam)?.[0]?.link;

			const filteredTOB_Link = data?.TERM_OFBUSINESS_URL?.filter(
				(value) => value.locale === languageParam)?.[0]?.link;

			const filteredTarget_Link = data?.TARGET_MARKET_URL?.filter(
				(value) => value.locale === languageParam)?.[0]?.link;

			const filteredDenominationArray = (
				data?.RISK_DISCLOSURE_URL?.find(
					value => value.locale === languageParam &&
					Array.isArray(value?.COR) && value.COR.includes(values.country)
				) ||
				data?.RISK_DISCLOSURE_URL?.find(
					value => value.locale === languageParam && !Array.isArray(value?.COR)
				)
			)?.link;

			setProductDisclosureLink(filteredproduct_Link);
			setFinancialGuideLink(filteredFinancial_Link);
			setTermsOfBusinessLink(filteredTOB_Link);
			setTargetMarketLink(filteredTarget_Link);
			setLink(filteredDenominationArray);
		}
	}, [languageParam, config, values.country]);

	const fetchFxcmRestrictedCountriesJson = () => {
		fetch(configurationServices(userEntity).restrictedCountriesURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setRestrictedCountriesList(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};

	const fetchCountryJson = () => {
		let countriesList = configurationServices(userEntity).countryList;
		// CX-51076: the EU-only list is built only once restrictedCountries.json
		// (euOnlyExcluded) is in, so an excluded country is never shown or
		// geo pre-selected while that file is still loading. If it fails to
		// load, nothing is excluded.
		const euOnlyExcludedRequest = isEuOnly
			? fetch(configurationServices(userEntity).restrictedCountriesURL)
				.then((response) => response.json())
				.then((restrictedData) => restrictedData?.euOnlyExcluded)
				.catch((e) => {
					console.log(e.message);
					return undefined;
				})
			: Promise.resolve(undefined);
		Promise.all([
			fetch(countriesList).then((response) => {
				return response.json();
			}),
			euOnlyExcludedRequest,
		])
			.then(([data, euOnlyExcluded]) => {

				if (isEuOnly) {
					const euList = getEuOnlyCountryList(data, euOnlyExcluded);
					if (languageParam !== "ar-AE") {
						dispatch(setUserEntity("FXCM_EU"));
					}
					const geoInEu = currentCountry
						? euList.find((item) => item.country_code === currentCountry)
						: null;
					setEuNoPreSelect(!geoInEu);
					setCountriesList(euList);
				} else {
					let location = (autoLoginResponse?.success && loginRes?.data?.["user-details"]?.countryOfResidence) ?
						loginRes.data["user-details"].countryOfResidence : currentCountry;

					let filterSelCountryCode = data.filter(
						(item) => item.country_code === location)?.[0]?.entity_code;

					if (languageParam !== "ar-AE") {
						dispatch(setUserEntity(filterSelCountryCode));
					}
					setCountriesList(data);
				}
			})
			.catch((e) => {
				console.log(e.message);
			});
	};

	const fetchJsonPlatForm = () => {
		fetch(configurationServices(userEntity).platformURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setPlateformData(data.list);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};

	const fetchJsonCurrency = () => {
		fetch(configurationServices(userEntity).CurrencyURL)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				setCurrencyList(data);
			})
			.catch((e) => {
				console.log(e.message);
			});
	};

	useEffect(() => {
		dispatch(setCountryListInState(countriesList));
	}, [countriesList]);

	const getCountryNameFromCountryCode = (countryCode) => {
		if (countryCode && countriesList?.length) {
			const findCountry = countriesList.find((element)=>element?.country_code === countryCode)
			return findCountry?.country_desc;
		}
		return countryCode;
	}

	useEffect(() => {
		if (authRes && !autoLoginResponse?.success) {
			setSignupLoader(false);
			setAlreadyExistError(false);
			setOnboardingInComplete(false);
			analytics?.trackEvent("onboarding_form_start", {
				onboardingStep: "Step 1",
				formEmail: authenticationResponse?.["signup-response"]?.users?.[0]?.username,
				formCountry: values.countryDesc ? values.countryDesc : getCountryNameFromCountryCode(userData?.countryOfResidence),
				engagementContext: "Create an account"
			});
			
			let useinfoData = {
				userName: authenticationResponse?.["signup-response"]?.users?.[0]?.username,
				email: values.email ? values.email : userData.email,
				countryOfResidence: values.country
					? values.country
					: userData.countryOfResidence,
				locale: DOMPurify.sanitize(localStorage.getItem("i18nextLng")),
				authToken: authenticationResponse?.["login-response"]?.token || "",
				currentStep: null
			};
			useinfoData.currentStep = "SIGN_UP"
			dispatch(updateUserInfo(useinfoData));

		}
	}, [
		authRes,
		values,
		platform,
		plateformData,
		authenticationResponse,
		currencyList,
		getAllEnLabels,
		savedCurrencyValue,
		userData.countryOfResidence,
		userData.userName,
		userData.email,
		rbName
	]);

	const handleClickShowPassword = () =>{
		
		setValues({
			...values,
			showPassword: !values.showPassword,
		});
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	  const handleKeyChange = (event) => {
		dispatch(coolingPeriodSlice(false));
		setAccountLock(false)
		if (event.key === 'Tab' && highlightedOption) {
		  event.preventDefault(); 
		  event.target.value = highlightedOption?.label;
		  emailRef?.current?.focus();
		  setValues({ ...values, email: event.target.value });
		  passwordRef?.current?.focus();
		  setMandatoryError({ ...mandatoryError, email: false });
          setError({ ...error, email: false });
		}
	
		if (event.key === 'Enter') {
			event.preventDefault(); 
			const isCustomInput = !(filteredDomains || []).some(
				(option) => option.label === event.target.value
			  );
			if (isCustomInput) {
				setValues({ ...values, email: event.target.value });
			}
		  }
	  }; 

const handleChange = (prop) => (event) => {
	if (prop === "password") {
		setInvalidPass(false);
      setMandatoryError({ ...mandatoryError, password: false });
    }
    setValues({ ...values, [prop]: event.target.value });

    if (prop === "email") {
		const value = event.target.value;
		const charecters = value.split('');	
		setSkipEmailField(false)	
		
		if((EMAIL_AUTO_SUGGESTION.test(charecters[0]))){
      if (event.target.value.length > 0 && !event.target.value?.includes("@")) {
        const filtered = suggestion?.map(
          (domain) => `${event.target.value}${domain.label}`
        );
        const options = filtered.map((domain, index) => ({
          id: String(index + 1),
          label: domain,
        }));
        setFilteredDomains(options);
      } else {
        setFilteredDomains([]);
      }
	}else {
        setFilteredDomains([]);
      }

       if (
			values.email?.toLowerCase().includes('fxcm') || values.email?.toLowerCase().includes('fuhui')
    	) {
        //NOSONAR
        
        setFxcmError(true);
      } else {
        setFxcmError(false);
      }
      setAlreadyExistError(false);
    }
  };

  
  const handleSuggessionOnCountryChange = () => { 
	if (values.email.length === 0 || !values.email?.includes("@")) {
		const filtered = suggestion?.map(
			(domain) => `${values.email}${domain.label}`
		);
		const options = filtered?.map((domain, index) => ({
			id: String(index + 1),
			label: domain,
		}));
	  	setFilteredDomains(options);
	} else {
		setFilteredDomains([]);
	}
  }

	const handleBlurEmail = () =>{
		setTouched({ ...touched, email: true });
		const emailRegex = CUSTOM_EMAIL.test(values.email);
		const onlyAlphanumeric = ONLY_ALPHA_NUMERIC.test(values.email);
		const specialRegex = SPECIAL_REGEX_FOR_EMAIL.test(values.email);
		const consecutiveRegex = CONSECUTIVE_REGEX.test(values.email);
		setAlreadyExistError(false);
		const isEmailHavingFxcmOrFuhui = values.email?.toLowerCase().includes('fxcm') || values.email?.toLowerCase().includes('fuhui')
		
		if ( isEmailHavingFxcmOrFuhui )
		{
			setFxcmError( true );
			setError({ ...error, email: true });
		}
		else
		{
			setFxcmError( false );
			setError({ ...error, email: false });
		}

		setMandatoryError({ ...mandatoryError, email: false });
		if (emailRegex && specialRegex && consecutiveRegex && !onlyAlphanumeric) {
			setError({ ...error, email: false });				
		} 
		
		if(!emailRegex && values.email.length>0){
			setError({ ...error, email: true });					
		} 

		if (values.email.length > config?.emailMaxLength) {
			setError({ ...error, email: true });
			setEmailLengthError(true);
		} else {
			setEmailLengthError(false);
		}
	};

	const handleBlurPassword = () => {
		setTouched({ ...touched, password: true });
		const isHavingSpace = HAVING_SPACE.test(values.password);
		const isHavingCertainSpeChar = CERTAIN_SPECIAL_CHARECTORS.test(values.password);

		if (touched.password) {
			setMandatoryError({ ...mandatoryError, password: values.password === "" });
			if (
			(!isHavingSpace && !isHavingCertainSpeChar) &&
			HAVING_UPPERCASE_LETTERS.test(values.password) &&
			HAVING_NUMERIC.test(values.password) &&
			HAVING_LOWERCASE_LETTERS.test(values.password) &&
			CHECK_LENGTH_MIN_8_MAX_15.test(values.password)
			) {
			setError({ ...error, password: false });			
			} else if(values.password.length>0) {
			setError({ ...error, password: true });			
			} else{
				setError({ ...error, password: false });
			}

			if(values.email.length === 0 && values.password.length>0){
				setSkipEmailField(true)
				setError({ ...error, email: true });
			} 
		}
	};


	const validation = () => {
		
		let isValid = true;
		
		if (error.password || error.email || error.country) {
			isValid = false;
		}
		
		if (
			values.email === "" ||
			values.password === "" ||
			values.country === ""
		) {
			isValid = false;
		}
		return isValid;
	};
	const handleCheckboxChange = (e) => {
		const isChecked = e.target.checked;
		setEmailConset(!isChecked);
		setSmsConset(!isChecked);
		setMarketingConsent(!isChecked);
	};

	const formSubmit = (e) => {
		e.preventDefault();
		// Never allow submission for a restricted country (CX-50769) or a
		// country-of-residence blocked country (CX-51003/CX-51004).
		if (
			values.country &&
			(restrictedCountriesList?.restricted?.includes(values.country) ||
				restrictedCountriesList?.countryBlocked?.includes(values.country))
		) {
			return;
		}
		const isEmailEmpty = values.email === "";
		const isCountryEmpty = values.country === "";
		const isPasswordEmpty = values.password === "";
		setMandatoryError({
			...mandatoryError,
			email: isEmailEmpty,
			password: isPasswordEmpty,
			country: isCountryEmpty,
		});
			setInvalidPass(false)
		if (validation()) {
			let updateValue = {};

			if (userEntity === "FXCM_UK" || userEntity === "FXCM_SVG") {
					updateValue = {
					emailConsent: false,
					smsConsent: false,
					marketingConsent: false,
				};
			} else if (userEntity === "FXCM_AU") {
			updateValue = {
				emailConsent: emailConset,
				smsConsent: smsConsent,
				marketingConsent: marketingConsent,
			};
			} else if (userEntity === "FXCM_EU") {
			updateValue = {
				emailConsent: emailConset,
				smsConsent: smsConsent,
			};
			} else {
			return;
			}

			window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
			setValues({ ...values });
			setSignupLoader(true);
			const trackingId = window?.__fxcmGtm?.get?.CLIENTID;
			const gclId = window?.__fxcmGtm?.get?.GCLID;

			dispatch(authenticateUser( { ...updateValue, ...values },esmaText, ip,
				rbName,
				campaignId?.replace("SFS-", ""),
				product,
				languageParam,
				trackingId,
				coreg,
				gclId,
				irpid
			)
			);
		}
	};

	useEffect(() => {
		if (authError) {
			const handleInvalidEmail = () => {
				setError({ ...error, email: true, password: false });
				setInvalidPass(false);
				setTimeout(() => {
					dispatch(authenticationError({}));
				}, 500);
			}

			const handleInvalidPassword = () => {
				setError({ ...error, email: false, password: true });
				setInvalidPass(true);
				setTimeout(() => {
					dispatch(authenticationError({}));
				}, 500);
			}

            const handleUserNotWhitelistedError = () => {
                setError({ ...error, email: true });
                setFxcmError(true);
            }

			const handleAlreadyExistEmail = () => {
				setError({ ...error, email: true });
                setAlreadyExistError(true);
				setTimeout(() => {
                    dispatch(authenticationError({}));
                }, 500);
			}
 
            const handleUserEmailAlreadyExistOrAccountLockedFxma = () => {
				emailExistOrAdditionalLabel.current = "EXIST_EMAIL_ADDITIONAL_ACCOUNT";
                handleAlreadyExistEmail();
            }
           
            const handleUserOnboardingIncompleteOrAccountLockedCxLogin = () => {
                setOnboardingInComplete(true);
				emailExistOrAdditionalLabel.current = "EMAIL_ALREADY_EXIST";
				handleAlreadyExistEmail();
            }
 
            const handleRbNotAllowedError = () => {
                setCountryType("rb_cor_error");
                setError({ ...error, country: true });
            }
 
            switch(authError.message) {
                case "USER_NOT_WHITELISTED_ERROR":
                    handleUserNotWhitelistedError();
                    break;
                case "USER_EMAIL_ALREADY_EXIST":
                case "USER_ACCOUNT_LOCKED_FXMA":
                    handleUserEmailAlreadyExistOrAccountLockedFxma();
                    break;
                case "USER_ONBOARDING_INCOMPLETE":
                case "USER_ACCOUNT_LOCKED_CX_LOGIN":
                    handleUserOnboardingIncompleteOrAccountLockedCxLogin();
                    break;
                case "RB not allowed":
                    handleRbNotAllowedError();
					break;
				case "Invalid Password !":
					handleInvalidPassword();
					break;
				case "Invalid Email !":
					handleInvalidEmail();
					break;
                default:
                    break;
            }
 
            setSignupLoader(false);
        }
    }, [authError]);

	useEffect(() => {
		
		if (entity && languageParam !== "ar-AE") {
			dispatch(setUserEntity(entity));
		}
	}, [entity]);

	useEffect(() => {
		const findLanguage = entityLanguageList?.find((lang) => lang.key === languageParam);
		const isFindLanguageBool = Boolean(findLanguage);
		setIsFindLanguage(isFindLanguageBool);
	}, [entityLanguageList, languageParam]);

	useEffect(()=>{
		if(coolingPeriod){			
			setSignupLoader(false)
			setAccountLock(true)
		}
	},[entity,coolingPeriod])

	useEffect(() => {
		if (userEntity) {
			const filteredData = Object.fromEntries(Object.entries(langList).filter(([_, value]) =>
				value.entity.includes(userEntity)
			));
				
					if(filteredData){
						if (direction.status === false) {
							if (urlLang) {
								const languageDetails = filteredData[urlLang];
								let isLanguagePresent = Boolean(languageDetails);
								if (isLanguagePresent) {
									dispatch(languagequeryParam(urlLang));
								} else {
									dispatch(languagequeryParam("en-US"));
								}
							} else {
								const languageDetails = filteredData[languageParam];
								let isLanguagePresent = Boolean(languageDetails);
								if (isLanguagePresent) {
									dispatch(languagequeryParam(languageParam));
									setLocale(languageParam)
								} else {
									dispatch(languagequeryParam("en-US"));
									setLocale("en-US");
								}
							}
						} else {
							dispatch(languagequeryParam("ar-AE"));
						}
			}
			
		}
	}, [userEntity, languageParam])

	useEffect(() => {
		if (!autoLoginResponse) {
			if (direction.status === false) {
				if (!isFindLanguage) {
					dispatch(languagequeryParam("en-US"));
				}
				if (values?.country === "DE") {
					dispatch(languagequeryParam("de-DE"));
				}
			} else {
				dispatch(languagequeryParam("ar-AE"))
			}
		}
	// languageParam intentionally excluded — reading it here would re-fire this effect on every
	// dispatch it makes, including the stale localStorage("i18nextLng") read that used to live in
	// the removed else-branch. i18nextLng is written asynchronously by i18next (after reloadResources
	// + changeLanguage resolve), so a synchronous read here always lagged one step behind Redux
	// languageParam, producing a zh-CN <-> en-US ping-pong on entity switches like China. When
	// isFindLanguage is true the active language is already valid for the entity — no re-dispatch needed.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isFindLanguage, direction.status])
	
	const handleClickMain = (value) => {
        const handleCountrySelection = (value) => {
            dispatch(arabicLanguagequeryParam(false));
            sessionStorage.setItem("PRE_SELECTED_COUNTRY", value.country_code);
            dispatch(setUserEntity(value.entity_code));
            setMandatoryError({ ...mandatoryError, country: false });
            setValues({
                ...values,
                country: value.country_code,
                countryDesc: value.country_desc,
                entity: value.entity_code,
            });
            setEntity(value.entity_code);
            dispatch(getUserCurrentLocation(value.country_code));
            emailRef?.current?.focus();
            if (value.entity_code !== "FXCM_SVG" || value.entity_code !== "FXCMNO") {
                direction.status = false;
            }
 
            if (value.country_code === "DE") {
                dispatch(languagequeryParam("de-DE"));
            }
        }

        const handleCountryRestriction = (value) => {
            // CX-51004 req 1.1: countries on the CX-51003 blocked list get the
            // COUNTRY_BLOCKED copy (req #2), not the generic COUNTRY_NOTELIGIBLE
            // message. Checked before `restricted` because every blocked country is
            // also present there — so if this bucket is absent or empty, behaviour
            // degrades safely to the pre-existing restricted-country message.
            const findCountryBlocked = restrictedCountriesList?.countryBlocked?.find(
                (item) => item === value.country_code
            );
            const findCountryrestricted = restrictedCountriesList?.restricted.find(
                (item) => item === value.country_code
            );
            if (findCountryBlocked) {
                setError({ ...error, country: true });
                setCountryType("countryBlocked");
            } else if (findCountryrestricted) {
                setError({ ...error, country: true });
                setCountryType("restricted");
            } else {
                const findMisc = restrictedCountriesList?.misc.find(
                    (item) => item === value.country_code
				);
				const traduAppLink = process.env.REACT_APP_TRADU_LINK;
				let traduRedirect = false;
				
					if (traduAppLink && traduAppLink !== "" && traduAppLink !== null) {
						traduRedirect = restrictedCountriesList?.traduRedirect.find(
							(item) => item === value.country_code
						);
					}
				
				if (findMisc) {
                    setError({ ...error, country: true });
                    setCountryType("misc");
				} else if (traduRedirect) {
					setError({ ...error, country: true });
					setCountryType("traduRedirect");
				} else {
                    setError({ ...error, country: false });
                }
            }
        }
 
        if (value) {
            handleCountrySelection(value)
        } else {
            setValues({ ...values, country: "" });
        }
 
        if (value?.entity_code) {
            handleCountryRestriction(value)
        } else {
            setError({ ...error, country: false });
        }
	};

	useEffect(() => {

		if (hasAutoSelectedPreselectedRef.current) return;
		if (config && restrictedCountriesList && preSelectedLocation !== "" && preSelectedLocation && countriesList !== undefined) {
			hasAutoSelectedPreselectedRef.current = true;
			const preSelectedCountryObject = countriesList?.filter((data) => data.country_code === preSelectedLocation)?.[0];
			handleClickMain(preSelectedCountryObject);
		}
	}, [preSelectedLocation, countriesList, config, restrictedCountriesList]); // eslint-disable-line react-hooks/exhaustive-deps
	useEffect(() => {
    	handleBlurEmail();
	}, [values.email]);

	useEffect(() => {
		handleBlurPassword();
	}, [values.password]);

	// CX-51004/CX-51021: resolves the block copy from the blocked country's
	// OWNING entity bundle (see countryBlocked.js) rather than whatever entity
	// i18next currently has loaded. Re-runs on languageParam so a language
	// switch after the block still re-translates this message.
	useEffect(() => {
		let cancelled = false;
		if (isCountryBlockedResponse(signUpRes)) {
			resolveCountryBlockedMessage(
				getLabel,
				signUpRes?.additionalProperties?.countryOfResidence,
				restrictedCountriesList,
				languageParam
			).then((message) => {
				if (!cancelled) setCountryBlockedMessage(message);
			});
		} else {
			setCountryBlockedMessage(null);
		}
		return () => {
			cancelled = true;
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [signUpRes, restrictedCountriesList, languageParam]);



	const handleClick = (value) => {
		// A manual selection takes precedence; never let the one-shot
		// pre-selected auto-select fire afterwards and overwrite it. See CX-50769.
		hasAutoSelectedPreselectedRef.current = true;
		handleClickMain(value);
		dispatch(coolingPeriodSlice(false));
		setAccountLock(false)
	};

	const handleOnKeyDown = () => {
		const isHavingSpace = HAVING_SPACE.test(values.password);
		const isHavingCertainSpeChar = CERTAIN_SPECIAL_CHARECTORS.test(values.password);
		if (
			(!isHavingSpace && !isHavingCertainSpeChar) &&
			HAVING_UPPERCASE_LETTERS.test(values.password) &&
			HAVING_NUMERIC.test(values.password) &&
			HAVING_LOWERCASE_LETTERS.test(values.password) &&
			CHECK_LENGTH_MIN_8_MAX_15.test(values.password)
		) {
			setError({ ...error, password: false });
		}
	};

	const handleOnfocus = () => {
		setFocus(false);
	};

	const getJSXHelperText = () => {
		if (fxcmError) {
			return (
				<div style={{ color: "#F44336" }}>
				<FXCMTrans defaults={getLabel(config?.EmailFXCMERROR)} />
				</div>
			);
		}
		if (error.email && !error.country && alreadyExistError) {
			return (
				<div style={{ color: "#F44336" }}>
					<FXCMTrans
						defaults={getLabel(emailExistOrAdditionalLabel.current)}
						values={{
							url: onboardingInComplete ? "/login" : "https://www.myfxcm.com/fxma/loginbp",
							tag: onboardingInComplete ? "Link" : "a",
							refAttri: onboardingInComplete ? "to" : "href"
						}}
					/>
				</div>
			);
		}
		return null;
	  };
	  
	  const getTextHelperText = () => {
			if (emailLengthError) {
				return getLabel(config?.emailLenghtError);
			}
			if (mandatoryError.email) {
				return getLabel(config?.MANDATORY_CHECK);
			}
			if (error.email && !error.country && !alreadyExistError) {
				return getLabel(skipEmailField? '':config?.EmailErrorText);
			}
			return "";
	  };

	const validatePasswordLength = () => {
		if (CHECK_LENGTH_MIN_8_MAX_15.test(values.password)) {
			return true;
		} else if(focus || values.password.length > 15) {
			return false;
		}
		return null
	}

	const validatePasswordContainsUpperAndLowerCase = () => {
		const isHavingLowerCase = HAVING_LOWERCASE_LETTERS.test(values.password);
		const isHavingUpperCase = HAVING_UPPERCASE_LETTERS.test(values.password);
		if (isHavingLowerCase && isHavingUpperCase) {
			return true
		}  else if (focus) {
			return false
		}
		return null
	}

	const validatePasswordContainsNumeric = () => {
		const isHavingNumeric = HAVING_NUMERIC.test(values.password);
		if (isHavingNumeric) {
			return true
		}  else if (focus) {
			return false
		}
		return null
	}

	const validatePasswordDoesNotContainsSpacesAndCertainSpecialCharectors = () => {
		const isHavingSpace = HAVING_SPACE.test(values.password);
		const isHavingCertainSpeChar = CERTAIN_SPECIAL_CHARECTORS.test(values.password);
		return isHavingSpace || isHavingCertainSpeChar;
	}

	const isPasswordLengthValid = validatePasswordLength();
	const isPasswordContainsBothCases = validatePasswordContainsUpperAndLowerCase();
	const isPasswordContainsNumeric = validatePasswordContainsNumeric();
	const isHavingSpaceOrSpeChar = validatePasswordDoesNotContainsSpacesAndCertainSpecialCharectors();
	const getHelperText = getJSXHelperText() || getTextHelperText();
	// Derive restriction directly from the selected country so a stale/racing
	// setError (e.g. after a language switch) can't silently re-enable the
	// fields for a blocked country like Afghanistan. See CX-50769.
	const isRestrictedCountry = Boolean(
		values.country &&
			(restrictedCountriesList?.restricted?.includes(values.country) ||
				// CX-51004: keep the button disabled for a blocked country even if it is
				// not (yet) in `restricted` — the real CX-51003 list may add countries
				// that the legacy restricted list does not carry.
				restrictedCountriesList?.countryBlocked?.includes(values.country))
	);
	const enabled = error.country || isRestrictedCountry;

	if (!config || !restrictedCountriesList) {
        return <Loader />;
    }
	const isEuOrUkUser = (userEntity === "FXCM_EU" || userEntity === "FXCM_UK");
	const renderErrorHandling = () => {
        if (signUpRes && !signUpRes.success) {
            // CX-51004: country-of-residence block (CX-51003) arrives as a 400 whose
            // message is the bare code COUNTRY_BLOCKED. Without this the user would
            // get the generic SOMETHING_WENT_WRONG, which reads as a system fault
            // rather than an eligibility decision.
            if (isCountryBlockedResponse(signUpRes)) {
                return (
                    <FXCMErrorHandling
                        titleCondition={true}
                        title={getLabel(countryBlockedMessage)}
                        subTitleCondition={false}
                        image={errorFlat}
                        imgWidth={60}
                        imgHeight={60}
                        column={true}
                        PaddingTop={true}
                        subTitle={""}
                    />
                );
            }
            const title = (signUpRes?.status === 403) ? getLabel("SOMETHING_WENT_WRONG") : signUpRes.error || "";
			const subTitle = (signUpRes?.status === 403) ? getLabel("PLEASE_TRY_AGAIN_AFTER_SOMETIME") : getLabel("SOMETHING_WENT_WRONG") || "";
            return (
                <FXCMErrorHandling
                    titleCondition={true}
                    title={title}
                    subTitleCondition={true}
                    image={errorFlat}
                    imgWidth={60}
                    imgHeight={60}
                    column={true}
                    PaddingTop={true}
                    subTitle={subTitle}
                />
            );
        }
        return null;
    };

	const renderPasswordValidation = () => {
        if (error.password || values.password) {
			const validationItems = [
				{ condition: isPasswordLengthValid, message: getLabel(config.PASSWORD_LENGTH) },
				{ condition: isPasswordContainsNumeric, message: getLabel(config.PASSWORD_MIXIN) },
				{ condition: isPasswordContainsBothCases, message: getLabel(config.PASSWORD_CONTAIN) }
			];
            return (
                <Box className="password-validation-wrapper" sx={error.password ? { background: "#FDF0F2", p: 1.5, mt: 2 } : { background: "#fafafa", p: 1.5, mt: 2 }}>
                    <Typography className="default font-14">{getLabel(config.PASSWORD_MUST)}</Typography>
                    <ul className={direction.status ? "passowrd-validation-arabic" : ""}>
                        {validationItems.map(({ condition, message }) => (
                            <li key={message} className={`default ${condition ? "greenTick" : "redCross"}`}>
                                {message}
                            </li>
                        ))}
						{
							isHavingSpaceOrSpeChar ? <li className="redCross">{getLabel(config.PASSWORD_SPACES_OR_SPECIAL)}</li> : ''
						}
                    </ul>
                </Box>
            );
        }
        return null;
    };

	const getPasswordValidationMessage = () => {
		const validationItems = [
			{ message: getLabel(config.PASSWORD_LENGTH) },
			{ message: getLabel(config.PASSWORD_MIXIN) },
			{ message: getLabel(config.PASSWORD_CONTAIN) },
			{ message: getLabel(config.PASSWORD_SPACES_OR_SPECIAL) }
		];
		return (
			<Box className="password-validation-wrapper" sx={{ background: "#FDF0F2", p: 1.5, mt: 2 }}>
				<Typography className="default font-14">{getLabel(config.PASSWORD_MUST)}</Typography>
				<ul className={direction.status ? "passowrd-validation-arabic" : ""}>
					{validationItems.map(({ message }) => (
						<li key={message} className={`default`}>
							{message}
						</li>
					))}
				</ul>
			</Box>
		);
	};

	const renderCountryField = () => (
		<FormControl fullWidth sx={{ mt: 4 }}>
			<FXCMAutoComplete
				label={getLabel(config.countryLabel)}
				options={countriesList}
				handleClick={handleClick}
				disabled={enabled}
				sx={{ backgroundColor: enabled ? "#F0F0F0" : "" }}
				cssStyles={`
					custom-Autocomplete-wraaper valueAutoComplete1
					${error?.country && "valueAutoComplete auto-display-error"} 
					${direction?.status && "custom-Autocomplete-wraaper_arabic"} 
					${(error?.country && direction?.status) && "valueAutoComplete_Arabic"}
				`}
				textFieldSize="small"
				error={ mandatoryError.country || error.country || isRestrictedCountry || false }
				errorMessage={(() => {
					if (mandatoryError?.country) {
						return getLabel(config?.MANDATORY_CHECK);
					}
					if (error.country || isRestrictedCountry) {
						return countryType || "restricted";
					}
					return "";
					})()}
				restrictedCountries={restrictedCountriesList}
				currentLocation={currentCountry}
				preSelectedLocation={preSelectedLocation}
				screenType="signup"
				noDefaultSelection={euNoPreSelect}
			/>
		</FormControl>
	)
	
	const renderEmailField = () => (
		<FormControl
			fullWidth
			sx={{ mt: 2 }}
			className={
				direction.status
					? "custom-form-controler custom_form_controler_arabic"
					: "custom-form-controler"
			}
		>
			<Autocomplete
			freeSolo
        id="email-select"
		className="email-select"
        sx={{ width: "100%" }}
        options={values.email ? filteredDomains : []}
        autoHighlight
        disabled={enabled}
        getOptionLabel={(option) => option?.label || ""}
        inputProps={{ maxLength: 61 }}
		inputValue={values.email}
		onKeyDown={handleKeyChange}
		onHighlightChange={(event, option) => {
			setHighlightedOption(option); 
		  }}
        onChange={(e,newval) => {
			const email = newval ? newval.label : values.email;				
			if (email) {
    			setValues((prevValues) => ({ ...prevValues, email }));
    		 }
			setMandatoryError({ ...mandatoryError, email: false });
  			setError({ ...error, email: false }); 
			dispatch(coolingPeriodSlice(false));
			setAccountLock(false)
        }}
			onClose={() => {
				
				const isEmailInvalid =  values.email?.toLowerCase().includes('fxcm') || values.email?.toLowerCase().includes('fuhui')

				if (!isEmailInvalid) {
					setFxcmError(false);
				}
			}}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ mr: 2, flexShrink: 0, borderBottom: '1px solid #f0f0f0', fontFamily:"inherit", 
              padding: '8px 12px', }}
              {...optionProps}
            >
              {option.label}
            </Box>
          );
        }}
        InputProps={{
          	"data-testid": "email-input",
          }}
        renderInput={(params) => (
          <TextField
            {...params}
            value={values.email}
            onChange={handleChange("email")}
            name="email"
			inputProps={{
			   ...params.inputProps,
			   'data-testid': 'email-input',
			}}
            inputRef={emailRef}
            disabled={enabled}
            sx={{ width: "100%", backgroundColor: enabled ? "#F0F0F0" : "" }}
            onBlur={handleBlurEmail}
            error={error.email && !error.country}
            helperText={getHelperText}
            label={getLabel(config.emailLebel)}
            InputLabelProps={{
              style: { backgroundColor: enabled ? "#F0F0F0" : "", lineHeight:"70%" },
            }}
            variant="outlined"
			InputProps={{...params.InputProps,endAdornment:null}}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                  autoComplete: 'new-password', // disable autocomplete and autofill
				  				  
              },
            }}
          />
        )}
      />
		</FormControl>
	)

	const renderPasswordField = () => (
		<FormControl
			fullWidth
			sx={{ mt: 2 }}
			variant="outlined"
			className={`custom-form-controler ${error.password && "error-password"} ${direction.status && "custom_form_controler_arabic"}`}
		>
			<InputLabel
				htmlFor="password-input"
				disabled={enabled}
				style={{ background: enabled ? "#F0F0F0" : "" }}
			>
				{getLabel(config.passwordLabel)}
			</InputLabel>
			<OutlinedInput
				id="password-input"
				type={values.showPassword ? "text" : "password"}
				value={values.password}
				disabled={enabled}
				sx={{ backgroundColor: enabled ? "#F0F0F0" : "" }}
				onChange={handleChange("password")}
				inputProps={{
					'data-testid': 'password-input',
				}}
				onBlur={handleBlurPassword}
				onFocus={handleOnfocus}
				inputRef={passwordRef}
				onKeyDown={handleOnKeyDown}
				error={Boolean(error.password)}
				endAdornment={
					<InputAdornment position="end">
						{!enabled ? (
							<IconButton
								id="signup-password-visibility-toggle"
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								disabled={enabled}
								edge="end"
								data-testid="toggle-password-visibility"
							>
								{values.showPassword ? (
									<span className="material-symbols-outlined">
										remove_red_eye
									</span>
								) : (
									<span className="material-symbols-outlined">
										visibility_off
									</span>
								)}
							</IconButton>
						) : (
							""
						)}
					</InputAdornment>
				}
				label="Password"
			/>
			{!invalidPass && renderPasswordValidation()}
			{invalidPass && getPasswordValidationMessage()}
		</FormControl>
	)
	
	const initializeContactUs = () => {
		if (contactLink && contactLink.startsWith("https://")) {
			window.open(
				contactLink,
				"_blank",
				`width=${Math.floor(window.innerWidth * 0.75)},height=${window.innerHeight},noopener`
			);
		}
	};
	const privacyPolycyObj =
		config?.PRIVACY_POLYCY_URLS?.find(data =>
			data?.locale === languageParam &&
			Array.isArray(data?.COR) && data?.COR?.includes(values.country)
		) ||
		config?.PRIVACY_POLYCY_URLS?.find(data =>
			data?.locale === languageParam && !Array.isArray(data?.COR)
		);
	const privacyLink = privacyPolycyObj?.link || config?.PRIVACY_POLICY_LINK
	const signUpNote = getLabel( config.SIGN_UP_NOTE ).replace( '{{privacy_link}}', privacyLink );
	return (
		<div className={ isEuOrUkUser ? "customer-header2" : ""}>
			{isEuOrUkUser ? <EsmaBanner key="esmaBannerId" /> : ""}
			<Header country={values.country}/>
			{renderErrorHandling()}
			<Box sx={{ mt: isEuOrUkUser ? "142px" : "102px"}}>
				<div className="container-home">
					<Grid>
						<Grid item sx={{ textAlign: "center", md: 5 }}>
							<form onSubmit={formSubmit}>
								<CardHeader title={getLabel(config.loginHeader)} data-testid="SignUp_header" />
								<div className="sub-header">
									<CardSubHeader value={getLabel(config.SIGNUP_SUBHEADING)} data-testid="SignUp_SubHeader" />
								</div>
								{renderCountryField()}
								{renderEmailField()}
								{renderPasswordField()}
								{/* <Typography
									
								>{ processedSignUpNote}</Typography> */}
								<Typography align="center"
									sx={{ my: 2 }}
									id="signup-note-text"
									className={
										(direction?.status || languageParam === "ar-AE") ? "sub-text_Arabic" : "sub-text"
									}>
								{userEntity === "FXCM_EU" || userEntity === "FXCM_AU" ? (
									<FormControlLabel
										control={
											<Checkbox
											checked={!emailConset} // Controlled state
											onChange={handleCheckboxChange} // Correctly invoke the handler
											size="small"
											className="checkbox-small-signup"
											/>
										}
										label={
											<FXCMTrans
											defaults={getLabel(signUpNote)}
											/>
										}
										className="form-control-label-signup"
										/>

									) : (
									<FXCMTrans defaults={getLabel(signUpNote)} />
									)}
								</Typography>							
									{coolingPeriod && 
									<Box className="info-error" id="signup-info-error">
										<Box component="img" src={infoError} alt="info error" sx={{ width: "25px", height: "25px" }}  />									 
										<Typography className="help-text">
											{getLabel("CANT_PROCEED")}{" "}
											<a onClick={initializeContactUs} rel="noopener">
												{getLabel("CONTACT_US")}
											</a>
										</Typography>
									</Box>
									}
								<LoadingButton
									id="signup-button"
									loading={signupLoader}
									loadingPosition="end"
									type="submit"
									 disabled={!validation() || error.password || error.email || fxcmError || accountLock || enabled}
									 style={{
										backgroundColor: !validation() || error.password || error.email || fxcmError || enabled ? "#F0F0F0" : undefined,
										cursor: !validation() || error.password || error.email || fxcmError || enabled ? "not-allowed" : "pointer",
									 }}
									fullWidth
									variant="contained"
								>
									{getLabel("SIGN_UP")}
								</LoadingButton>
							</form>
							<Typography
								className="link-text"
								align="center"
								sx={{ my: 2, p: 0.5 }}
								md={{ p: 0 }}
								id="signup-account-existing"
							>
								<FXCMTrans
									defaults={getLabel("ALREADY_HAVE_ACCOUNT")}
									values={{ url: "/login" }}
								></FXCMTrans>
								
									<Link to="/login" id="onclick-login" style={{fontWeight:"bold"}}>
										{getLabel("LOGIN_TEXT")}
									</Link>  {languageParam === "sv-SE" && (<span style={{ color: "rgba(0, 0, 0, 0.68)" }}>{getLabel("FOR_ATT")}</span>)}
							</Typography>
							{config?.FOOTER_COPYRIGHT && (
								<div className="Footer_text" id="signup-footer-text">
									<Typography
										className={
											(direction?.status || languageParam === "ar-AE") ? "sub-text_Arabic" : "sub-text"
										}
									>
										<FXCMTrans
											defaults={getLabel(config.FOOTER_COPYRIGHT)}
											values={{
												year: new Date().getFullYear(),
												url: link,
												targetPage: true,
												product_disclosure_statement: productDisclosureLink,
												financial_services_guide: financialGuideLink,
												terms_of_business: termsOfBusinessLink,
												target_market_determination: targetMarketLink
											}}
										/>
									</Typography>
								</div>
							)}
						</Grid>
					</Grid>
				</div>
			</Box>
		</div>
	);
};

export default SignUpForm;
